/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { translate } from '../../common/translation/translate';

interface LinksProps {
    forecastRoute: string;
    mapsRoute: string;
    aqiRoute: string;
}

const mapStoreStateToProps = (storeState: object) => {
    const { weatherWidget } = storeState || {};
    const { 
        forecastRoute,
        mapsRoute,
        aqiRoute 
    } = weatherWidget || {};

    return {
        forecastRoute,
        mapsRoute,
        aqiRoute
    };
};

const mapDispatchToProps = {};

export const Links = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo((
    {
        forecastRoute,
        mapsRoute,
        aqiRoute
    }: LinksProps
) => {
    return (
        <LinksContainer>
            <LinkItem target='_blank' href={forecastRoute}>{translate('forecasts')}</LinkItem>
            <LinkItem target='_blank' href={mapsRoute}>{translate('maps')}</LinkItem>
            <LinkItem target='_blank' href={aqiRoute}>{translate('airquality')}</LinkItem>
        </LinksContainer>
    );
}));

Links.displayName = 'Links';

const LinksContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: normal;
    height: 18%;
`;

const LinkItem = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 33.3%;
    font-size: 3vw;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    text-decoration: none;
    color: #f7f8fa;
    &:hover{
        cursor: pointer;
    }
`;